<dialog [id]="modalDialogId" class="modal">
    <div class="modal-box w-[800px] max-w-[800px] mobile:max-w-[90vw]" *ngIf="!uploading">
        <div class="flex w-full justify-between items-center">
            <h3 class="text-3xl font-bold">{{ 'locations.add_new' | transloco }}</h3>
            <button (click)="closeModal()"><img src="assets/icons/close-circle-black.svg" alt="X"></button>
        </div>

        <p class="py-4 text-neutral-500">{{ 'locations.two_options' | transloco }}</p>

        <div class="flex gap-4 mobile:flex-col">
            <div class="w-1/2 mobile:w-full h-[400px] mobile:h-[200px] min-h-[250px]">
                <app-location-file-upload [toast]="toast" [showListOfRecentUploadsAfterUpload]="true"></app-location-file-upload>
            </div>
            <div
                class="w-1/2 mobile:w-full h-[400px] rounded-md border-spacing-2 border-2 border-border bg-white flex flex-col justify-evenly items-center select-none min-h-[250px]">
                <div
                    class="w-[80px] h-[80px] flex items-center justify-center rounded-full text-white font-bold uppercase overflow-hidden bg-primary-300 mt-4">
                    <img src="assets/icons/magicpen.svg" width="60px" height="60px"
                        alt="{{ 'shared.upload_icon' | transloco }}">
                </div>

                <p class="text-center textarea-md text-neutral-500">{{
                    'shared.fill_information_manually.fill_all_relevant_info' | transloco }}<b class="text-black">{{
                        'shared.fill_information_manually.manually' | transloco }}</b></p>
                <div class="max-w-screen-sm w-11/12 mt-8 mb-6">
                    <app-primary-button buttonText="{{ 'shared.add_data' | transloco }}" (buttonClick)="addDataClick()"
                        [isDisabled]="false">
                    </app-primary-button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-box w-[800px] max-w-[800px] mobile:max-w-[90vw]" *ngIf="uploading">
        <div
            class="w-full h-full min-h-[300px] rounded-md border-spacing-2 border-2 border-primary-500 border-dashed bg-primary-200 flex flex-col justify-center items-center select-none">
            <p>{{fileName}}</p>
            <progress class="progress w-[50%] h-[4px] progress-primary bg-border mt-5" [value]="precentage"
                max="100"></progress>
            <p class="mt-5">{{ 'locations.extraction' | transloco }}</p>
        </div>

    </div>
    <form method="dialog" class="modal-backdrop">
        <button>Close</button>
    </form>
</dialog>